export default __webpack_public_path__ + "static/media/productDoc.ee0e5a5d.svg";